import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'app-redirect-to-my-menu-print',
  templateUrl: './redirect-to-my-menu-print.component.html',
  styleUrls: ['./redirect-to-my-menu-print.component.css']
})
export class RedirectToMyMenuPrintComponent implements OnInit {

  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.userService.getUser().subscribe(user => {
      window.location.href = '/' + user.urlId + '/print';
    });
  }

}
